import React from 'react';
import { defaultServiceContext } from '../../../contexts';
import { DesignBranchingEventType } from '../../../types';
import { getLatestBranchingEvent } from '../../../utilities';
import LoadingSpinnerButton from "./../LoadingSpinnerButton";

const { avsService } = defaultServiceContext;

export default class LastPulledWidget extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            commitsBehind: 0,
            message: "Loading..."
        }
        this.refreshBranchInfo = this.refreshBranchInfo.bind(this);
    }

    componentDidMount(){
        this.getMainBranchInfo();
    }

    refreshBranchInfo(){
        this.getMainBranchInfo();
    }

    // TODO: set a minimum timer on getMainBranchInfo
    // sleep(ms) {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }
    
    /**
     * how many pulls behind, last pulled at, parent latest, parent branch name
     * @param {*} client 
     * @param {*} mainBranch 
     */
    async getMainBranchInfo(){

        this.setState({updatingLastPulled: true});

        const { branching } = this.props.serialized;
        const {
            parent_branch_id: parentBranchId,
            parent_branch_name: parentBranchName
        } = getLatestBranchingEvent(
            branching,
            DesignBranchingEventType.initBranch
        );
        const parentLatestVersion = (
            await avsService.getLatestVersion(parentBranchId)
        )?.version;
        const commitsBehind = this.getCommitsBehind(parentLatestVersion);

        let message  = "";
        const commitsString = (commitsBehind === 1) ? "commit" : "commits";

        if(commitsBehind === 0){
            message = `Your branch is up to date with ${parentBranchName}`
        } else if (commitsBehind == null) {
            message = `Your branch is a major/minor version behind ${parentBranchName}`;
        } else {
            message = `Your branch is ${commitsBehind} ${commitsString} behind ${parentBranchName}`
        }

        this.setState({"message": message});
        this.setState({"commitsBehind": commitsBehind});

        this.setState({updatingLastPulled: false});
    }

    /**
     * latesVersion - lastPulled
     * @param {*} parentBranchingMap 
     * @returns 
     */
    getCommitsBehind(mainLatestVersion) {
        const initEvent = this.props.serialized.branching.filter(br => br.type === "init").pop();
        const lastPulledEvent = this.props.serialized.branching.filter(br => br.type === "pull").pop();
        const pullFrom = (lastPulledEvent) ? lastPulledEvent.pulled_at : initEvent.branched_at;
        const pullVersionSplit = pullFrom.split(".");
        const mainVersionSplit = mainLatestVersion.split(".");

        if (pullVersionSplit.length !== mainVersionSplit.length) {
            return null;
        }

        for (let i = 0; i < mainVersionSplit.length; ++i) {
            const mainPart = mainVersionSplit[i];
            const pullPart = pullVersionSplit[i];
            if (i === mainVersionSplit.length - 1) {
                return parseInt(mainPart, 10) - parseInt(pullPart, 10);
            } else if (mainPart !== pullPart) {
                return null;
            }
        }
    }

    render() {
        return (
            <div className="pull_status">
                <span style={{paddingRight: "4px"}}>{this.state.message}
                <LoadingSpinnerButton 
                    action = {this.refreshBranchInfo}
                    isLoading = {this.state.updatingLastPulled}
                />
                </span>
            </div>
        );
    }
}
